import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Image } from '@outdoor-voices/ui';
import { memo } from 'react';
import PropTypes from 'prop-types';
import { DESKTOP_IMAGE_SIZES, MOBILE_IMAGE_SIZES } from '../constants';
import css from './Assets.module.scss';
import Play from '../../../components/icons/Play';
import Video from '../../../components/Video';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Asset = function Asset(_ref) {
  var fullWidth = _ref.fullWidth,
      lazyload = _ref.lazyload,
      image = _ref.image,
      video = _ref.video;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [video && video.autoplay && /*#__PURE__*/_jsx(Video, _objectSpread(_objectSpread({}, video), {}, {
      autoPlay: video.autoplay,
      className: css.video,
      controls: video.controls,
      controlsList: "nodownload",
      crossOrigin: "anonymous",
      muted: video.muted,
      poster: video.poster.src,
      preload: "metadata",
      src: video.src,
      track: {
        src: video.subtitleUrl
      }
    })), video && !video.autoplay && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Video, _objectSpread(_objectSpread({}, video), {}, {
        className: css.video,
        sizes: DESKTOP_IMAGE_SIZES,
        src: video.src
      })), /*#__PURE__*/_jsx("div", {
        className: css.videoIcon,
        children: /*#__PURE__*/_jsx(Play, {})
      })]
    }), !video && image && fullWidth && /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
      alt: image.alt ? image.alt : "Detail Image For ".concat(title),
      lazyload: lazyload,
      sizes: MOBILE_IMAGE_SIZES,
      wrap: false
    })), !video && image && !fullWidth && /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
      lazyload: lazyload,
      sizes: DESKTOP_IMAGE_SIZES,
      wrap: false
    }))]
  });
};

Asset.defaultProps = {
  fullWidth: false,
  image: false,
  lazyload: true,
  video: false
};
Asset.propTypes = {
  fullWidth: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  image: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  lazyload: PropTypes.bool,
  video: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()])
};
export default /*#__PURE__*/memo(Asset);